import { map, distinctUntilChanged } from 'rxjs/operators';

/**
 * @param {Observable<playback-web-player.Media>} mediaUpdate$
 * @return {Observable<boolean>}
 */

const createIsLiveStream = mediaUpdate$ =>
    mediaUpdate$
        .pipe(
            map(({ isLive, isLinear }) => isLive || isLinear),
            distinctUntilChanged()
        );

export default createIsLiveStream;
